import * as React from "react";
import { cn } from "@/lib/utils";

interface GlowCardProps {
  children: React.ReactNode;
  className?: string;
  spotlight?: boolean;
}

export const GlowCard = ({ children, className }: GlowCardProps) => {
  return (
    <div
      className={cn(
        "group relative rounded-xl border border-border bg-card overflow-hidden transition-all duration-300",
        "hover:border-primary/50 hover:shadow-glow hover:scale-[1.02]",
        className
      )}
    >
      {/* Gradient border on hover - CSS only */}
      <div className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        <div className="absolute inset-[-1px] rounded-xl bg-gradient-to-r from-primary/50 via-transparent to-primary/50" />
        <div className="absolute inset-[1px] rounded-xl bg-card" />
      </div>

      {/* Spotlight effect - CSS radial gradient on hover */}
      <div 
        className="pointer-events-none absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        style={{
          background: "radial-gradient(600px circle at 50% 50%, hsl(var(--primary) / 0.1), transparent 60%)"
        }}
      />

      {/* Content */}
      <div className="relative z-10">{children}</div>

      {/* Corner accents */}
      <div className="absolute top-0 left-0 w-8 h-8 border-l-2 border-t-2 border-primary/0 group-hover:border-primary/30 transition-colors duration-300 rounded-tl-xl" />
      <div className="absolute bottom-0 right-0 w-8 h-8 border-r-2 border-b-2 border-primary/0 group-hover:border-primary/30 transition-colors duration-300 rounded-br-xl" />
    </div>
  );
};

GlowCard.displayName = "GlowCard";

export default GlowCard;
